/**
 * Created by Karol Kluska on 16.07.18.
 */

angular
  .module('app')
  .component('equipment', {
    templateUrl: 'app/shared/Equipment/Equipment.html',
    controller: Equipment,
    bindings: {
      name: '<',
      symbol: '<'
    }
  });

function Equipment() {}

Equipment.prototype = {
  $onInit: function () {
    this.iconClass = this.resolveIconClass(this.symbol);
  },

  // eslint-disable-next-line
  resolveIconClass: function (symbol) {
    switch (symbol) {
      case 'Adjoining rooms':
        return 'fa fa-lg fa-share-alt';
      case 'Air conditioning':
        return 'fa fa-lg fa-snowflake-o';
      case 'Alarm clock':
        return 'fa fa-lg fa-clock-o';
      case 'AM/FM radio':
        return 'fa fa-lg fa-volume-up';
      case 'Barbeque grills':
        return 'fa fa-lg fa-cutlery';
      case 'Bath tub with spray jets':
        return 'fa fa-lg fa-bath';
      case 'Bathrobe':
        return 'fa fa-lg fa-suitcase';
      case 'Bathroom amenities (free toiletries)':
        return 'fa fa-lg fa-leaf';
      case 'Bathtub':
        return 'fa fa-lg fa-bath';
      case 'Bathtub &whirlpool separate':
        return 'fa fa-lg fa-bath';
      case 'Bathtub only':
        return 'fa fa-lg fa-bath';
      case 'Bidet':
        return 'fa fa-lg fa-shower';
      case 'Cable television':
        return 'fa fa-lg fa-television';
      case 'CD player':
        return 'fa fa-lg fa-television';
      case 'Coffee/Tea maker':
        return 'fa fa-lg fa-coffee';
      case 'Color television':
        return 'fa fa-lg fa-television';
      case 'Computer':
        return 'fa fa-lg fa-desktop';
      case 'Connecting rooms':
        return 'fa fa-lg fa-exchange';
      case 'Cordless phone':
        return 'fa fa-lg fa-phone';
      case 'Desk':
        return 'fa fa-lg fa-sticky-note';
      case 'Desk with electrical outlet':
        return 'fa fa-lg fa-sticky-note';
      case 'Desk with lamp':
        return 'fa fa-lg fa-sticky-note';
      case 'Dishwasher':
        return 'fa fa-lg fa-database';
      case 'Fax machine':
        return 'fa fa-lg fa-fax';
      case 'Fireplace':
        return 'fa fa-lg fa-fire';
      case 'Free movies/video':
        return 'fa fa-lg fa-television';
      case 'Full kitchen':
        return 'fa fa-lg fa-cutlery';
      case 'Grecian tub':
        return 'fa fa-lg fa-bath';
      case 'Hairdryer':
        return 'fa fa-lg fa-thermometer-full';
      case 'Internet access':
        return 'fa fa-lg fa-globe';
      case 'Iron (ironing facilities)':
        return 'fa fa-lg fa-suitcase';
      case 'Ironing board':
        return 'fa fa-lg fa-suitcase';
      case 'Kitchen':
        return 'fa fa-lg fa-cutlery';
      case 'Kitchen supplies':
        return 'fa fa-lg fa-cutlery';
      case 'Kitchenette':
        return 'fa fa-lg fa-cutlery';
      case 'Laptop':
        return 'fa fa-lg fa-laptop';
      case 'List of movie channels available':
        return 'fa fa-lg fa-television';
      case 'Marble bathroom':
        return 'fa fa-lg fa-bath';
      case 'Microwave':
        return 'fa fa-lg fa-cutlery';
      case 'Minibar':
        return 'fa fa-lg fa-glass';
      case 'Oversized bathtub':
        return 'fa fa-lg fa-bath';
      case 'Pay per view movies on TV':
        return 'fa fa-lg fa-television';
      case 'Phone in bathroom':
        return 'fa fa-lg fa-phone';
      case 'Plates and bowls':
        return 'fa fa-lg fa-cutlery';
      case 'Private bathroom':
        return 'fa fa-lg fa-bath';
      case 'Refrigerator':
        return 'fa fa-lg fa-snowflake-o';
      case 'Refrigerator with ice maker':
        return 'fa fa-lg fa-snowflake-o';
      case 'Safe':
        return 'fa fa-lg fa-lock';
      case 'Separate closet':
        return 'fa fa-lg fa-suitcase';
      case 'Shower':
        return 'fa fa-lg fa-shower';
      case 'Silverware/utensils':
        return 'fa fa-lg fa-cutlery';
      case 'Sitting area':
        return 'fa fa-lg fa-check-square-o';
      case 'Soundproofed room':
        return 'fa fa-lg fa-volume-off';
      case 'Speaker phone':
        return 'fa fa-lg fa-volume-control-phone';
      case 'Stove':
        return 'fa fa-lg fa-cutlery';
      case 'Tables and chairs':
        return 'fa fa-lg fa-check-square-o';
      case 'Telephone for hearing impaired':
        return 'fa fa-lg fa-assistive-listening-systems';
      case 'VCR movies':
        return 'fa fa-lg fa-television';
      case 'Video games':
        return 'fa fa-lg fa-desktop';
      case 'Wake­up calls':
        return 'fa fa-lg fa-clock-o';
      case 'Whirpool':
        return 'fa fa-lg fa-bath';
      case 'Wireless internet connection':
        return 'fa fa-lg fa-wifi';
      case 'Air conditioning individually controlled in room':
        return 'fa fa-lg fa-snowflake-o';
      default:
        return 'fa fa-lg fa-check-square-o';
    }
  }
};
